// Drapeau du pilote : nouvelles saisies par la file pour ces organisations (liste servie par l'API) et abonnements.
// Éteint, les services appellent l'API directement ; une file déjà remplie continue d'être envoyée
const PILOT_SUBSCRIPTIONS = ['dev', 'admin'];

let pilotOrganizationIds = [];
let context = { activeOrganization: null, loginAsData: null };

// Liste des organisations du pilote (API ou dernière session)
export const setPilotOrganizationIds = (ids) => {
    pilotOrganizationIds = Array.isArray(ids) ? ids : [];
};

// Organisation active et « se connecter en tant que », tenus à jour par SyncManager
export const setOfflineFlagContext = (partial) => {
    context = { ...context, ...partial };
};

// Drapeau pour une organisation donnée ; jamais en « se connecter en tant que »
export const isOfflineEnabledFor = (activeOrganization, loginAsData) => {
    if (!activeOrganization || loginAsData) return false;
    const shortName = activeOrganization.subscription?.shortName?.toLowerCase();
    return pilotOrganizationIds.includes(activeOrganization.id) || PILOT_SUBSCRIPTIONS.includes(shortName);
};

// Drapeau pour le contexte courant
export const isOfflineEnabled = () => isOfflineEnabledFor(context.activeOrganization, context.loginAsData);
